export default __webpack_public_path__ + "static/media/learose2-768w.f0f7ed94.webp";